/* eslint-disable camelcase */
import visual from 'assets/images/product/visual.png';
import product from 'assets/images/product/product1.png';
import aeroQbitA1 from 'assets/images/product/AeroQbit-A.jpg';
import aeroQbitA2 from 'assets/images/product/AeroQbit-A(1).jpg';
import product2_3 from 'assets/images/product/product2_3.png';
import productD from 'assets/images/product/product_d.png';
import centralCorridor from 'assets/images/product/central_corridor_new.jpg';
import sideCorridor from 'assets/images/product/side_corridor.jpg';
import doubleHeightCeiling from 'assets/images/product/double_height_ceiling_new.jpg';
import airInletWindow from 'assets/images/product/air_inlet_window.jpg';
import koreaOutline from 'assets/images/product/korea_outline.png';
import loc1 from 'assets/images/product/location_placeholder_1.svg';
import loc2 from 'assets/images/product/location_placeholder_2.svg';
import loc3 from 'assets/images/product/location_placeholder_3.svg';
import nonsan1 from 'assets/images/product/nonsan_1.jpg';
import nonsan2 from 'assets/images/product/nonsan_2.jpg';
import nonsan3 from 'assets/images/product/nonsan_3.jpg';
import nonsan4 from 'assets/images/product/nonsan_4.jpg';
import nonsan5 from 'assets/images/product/nonsan_5.jpg';
import nonsan6 from 'assets/images/product/nonsan_6.jpg';
import haman1 from 'assets/images/product/haman_1.jpg';
import haman2 from 'assets/images/product/haman_2.jpg';
import yeongcheon3 from 'assets/images/product/yeongcheon_3.jpg';
import yeongcheon4 from 'assets/images/product/yeongcheon_4.jpg';
import yeongcheon5 from 'assets/images/product/yeongcheon_5.jpg';
import yeongcheon6 from 'assets/images/product/yeongcheon_6.jpg';
import jeju1 from 'assets/images/product/jeju_1.jpg';
import jeju2 from 'assets/images/product/jeju_2.jpg';
import jeju3 from 'assets/images/product/jeju_3.jpg';
import jeju4 from 'assets/images/product/jeju_4.jpg';
import jejuAqd1 from 'assets/images/product/jeju_aqd_1.jpg';
import jejuAqd2 from 'assets/images/product/jeju_aqd_2.jpg';
import jejuAqd3 from 'assets/images/product/jeju_aqd_3.jpg';
import jejuAqd4 from 'assets/images/product/jeju_aqd_4.jpg';
import jejuAqd5 from 'assets/images/product/jeju_aqd_5.jpg';
import jejuAqd6 from 'assets/images/product/jeju_aqd_6.jpg';
import jejuKone1 from 'assets/images/product/jeju_kone_1.jpg';
import jejuKone2 from 'assets/images/product/jeju_kone_2.jpg';
import jejuKone3 from 'assets/images/product/jeju_kone_3.jpg';
import jejuKone4 from 'assets/images/product/jeju_kone_4.jpg';
import pocheon1 from 'assets/images/product/pocheon_1.jpg';
import pocheon2 from 'assets/images/product/pocheon_2.jpg';
import pocheon3 from 'assets/images/product/pocheon_3.jpg';
import cheorwon1 from 'assets/images/product/cheorwon_1.jpg';
import cheorwon2 from 'assets/images/product/cheorwon_2.jpg';
import cheorwon3 from 'assets/images/product/cheorwon_3.jpg';
import cheorwon4 from 'assets/images/product/cheorwon_4.jpg';
import uiryeong1 from 'assets/images/product/uiryeong_1.jpg';
import uiryeong2 from 'assets/images/product/uiryeong_2.jpg';
import uiryeong3 from 'assets/images/product/uiryeong_3.jpg';
import uiryeong4 from 'assets/images/product/uiryeong_4.jpg';
import yeoncheon1 from 'assets/images/product/yeoncheon_1.jpg';
import yeoncheon4 from 'assets/images/product/yeoncheon_4.jpg';
import miryangA2 from 'assets/images/product/miryang_a_2.jpg';
import miryangA3 from 'assets/images/product/miryang_a_3.jpg';
import miryangA4 from 'assets/images/product/miryang_a_4.jpg';
import miryangA5 from 'assets/images/product/miryang_a_5.jpg';
import miryangA6 from 'assets/images/product/miryang_a_6.jpg';
import miryangB1 from 'assets/images/product/miryang_b_1.jpg';
import miryangB2 from 'assets/images/product/miryang_b_2.jpg';
import miryangB3 from 'assets/images/product/miryang_b_3.jpg';

// 설치/운용 지역 지도 핀
//  - x/y : 지도 이미지 대비 % 좌표
//  - imgs: 지역별 설치 사진 배열(여러 장). 실제 사진 확보되는 대로 교체
const dLocationMap = {
  base: koreaOutline,
  pins: [
    { name: `철원`, x: 41, y: 12, imgs: [cheorwon1, cheorwon2, cheorwon3, cheorwon4] },
    { name: `포천`, x: 37, y: 19, imgs: [pocheon1, pocheon2, pocheon3] },
    { name: `연천`, x: 33, y: 13, imgs: [yeoncheon1, yeoncheon4] },
    { name: `논산`, x: 29, y: 51, imgs: [nonsan1, nonsan2, nonsan3, nonsan4, nonsan5, nonsan6] },
    { name: `의령`, x: 44, y: 66, imgs: [uiryeong1, uiryeong2, uiryeong3, uiryeong4] },
    {
      name: `밀양`,
      x: 50,
      y: 63,
      groups: [
        { label: `농장 1`, imgs: [miryangA2, miryangA3, miryangA4, miryangA5, miryangA6] },
        { label: `농장 2`, imgs: [miryangB1, miryangB2, miryangB3] },
      ],
    },
    {
      name: `제주도`,
      x: 15,
      y: 95,
      groups: [
        { label: `농장 1`, imgs: [jejuAqd1, jejuAqd2, jejuAqd3, jejuAqd4, jejuAqd5, jejuAqd6] },
        { label: `농장 2`, imgs: [jejuKone1, jejuKone2, jejuKone3, jejuKone4] },
      ],
    },
  ],
};

// AeroQbit-A 전용 설치/운용 지역 (기존 A 지도의 지역만)
const aLocationMap = {
  base: koreaOutline,
  pins: [
    { name: `영천`, x: 57, y: 55, imgs: [yeongcheon3, yeongcheon4, yeongcheon5, yeongcheon6] },
    { name: `함안`, x: 43, y: 67, imgs: [haman1, haman2] },
    { name: `제주도`, x: 15, y: 95, imgs: [jeju1, jeju2, jeju3, jeju4] },
  ],
};

export const krProduct = {
  title: `제품소개`,
  subTitle: `Product`,
  visual,
  products: [
    {
      subject: `AeroQbit-D`,
      category: `축사용 제습기 · 냉각·습도 조절`,
      subjectDesc: `축사용 제습/냉각 시스템`,
      aeroQbitImg: productD,
      aeroQbitAlt: `축사용 제습기 AeroQbit-D - 액상 냉매 기반 축사용 제습/냉각 시스템`,
      productList: [
        {
          title: `제품 설명`,
          desc: `· 액상 냉매를 이용한 제습/냉각\n· 축사 구조별 최적 설계 및 적용\n· 중앙복도·편복도·중천장·창문 입기 등\n  다양한 밀폐형 축사 형태에 적용\n· 축사 도면 기반 설계\n· 축사 환기 연계로 효율적 제습/냉각`,
        },
        {
          title: `제품 스펙`,
          content: [
            { label: `냉각기 용량`, value: `축사별 2HP, 5HP 적용` },
            { label: `열교환 모듈`, value: `축사 크기·구조에 따라 적용` },
            { label: `모듈 규격`, value: `400 × 330 × 250 (mm)` },
            { label: `모듈 송풍량`, value: `1,000 CMH (m³/h)` },
            { label: `모듈 적용 개수`, value: `축사별·구조별 상이` },
            { label: `전체 소모전력`, value: `2HP 3.5kW / 5HP 7.5kW 내외 (축사별 상이)` },
            { label: `원격 제어`, value: `LTE 기반 원격 제어 가능` },
            { label: `예측 제어`, value: `축사 온도 추이 예측 기반 제어 (축사별 옵션)` },
          ],
        },
        {
          title: `제품 추가 정보`,
          desc: `· 스마트팜 ICT 융복합 확산사업 등록 기기\n· 조달청 등록에 따른 보조사업 신청 가능`,
        },
      ],
      subject1: `AeroQbit-D 제품설치`,
      subject1Desc: `축사 형태별 설치 형태`,
      installProduct: [
        { label: `중앙복도`, img: centralCorridor, alt: `중앙복도형 돈사 축사용 제습기 AeroQbit-D 설치 형태` },
        { label: `편복도`, img: sideCorridor, alt: `편복도형 축사 제습기 AeroQbit-D 설치 형태` },
        { label: `중천장`, img: doubleHeightCeiling, alt: `중천장형 축사 축사용 제습/냉각 시스템 AeroQbit-D 설치 형태` },
        { label: `입기창`, img: airInletWindow, alt: `입기창 설치형 돈사 제습기 AeroQbit-D 열교환 모듈` },
      ],
      subject2: `AeroQbit-D 설치장소`,
      subject2Desc: `설치·운용 지역`,
      locationMap: dLocationMap,
    },
    {
      subject: `AeroQbit-A`,
      // 검색 키워드 라벨 (제품명 위 eyebrow) — 서버 SEO(seo-routes.json)와 문구 일치
      category: `축사용 공기청정기 · 악취 저감`,
      subjectDesc: `내부 공기 순환 & 악취 저감 시스템`,
      aeroQbitImg: product,
      aeroQbitAlt: `축사용 공기청정기 AeroQbit-A - DEP 기반 축사 악취 저감 장치`,
      productList: [
        { title: `제품 설명`, desc: `내부 공기 순환\n악취 저감 시스템` },
        {
          title: `제품 스펙`,
          content: [
            { label: `제품 크기(cm)`, value: `W103 × D40 × H65` },
            { label: `입력 전원`, value: `220V (단상)` },
            { label: `소모 전력`, value: `150W` },
            { label: `물 입력 규격`, value: `1/4인치 원터치 방식` },
            { label: `물 사용량`, value: `20L/day (배출시간조절가능)` },
            { label: `악취저감방식`, value: `인라인 송풍` },
            { label: `운용위치`, value: `내부 환경에 따른 설치` },
            { label: `유지/보수`, value: `모듈 교환 방식 (교환주기 : 3개월)` },
          ],
        },
        { title: `제품 정보`, desc: `특별사항` },
      ],
      subject1: `AeroQbit-A 제품설치`,
      installProduct: [
        { img: aeroQbitA1, alt: `축사용 공기청정기 AeroQbit-A 돈사 내부 설치 모습` },
        { img: aeroQbitA2, alt: `축사 공기청정기 AeroQbit-A 설치 및 공기 순환 운용 모습` },
      ],
      subject2: `AeroQbit-A 설치장소`,
      subject2Desc: `설치·운용 지역`,
      locationMap: aLocationMap,
    },
  ],
};

export const enProduct = {
  title: `제품소개_en`,
  subTitle: `Product`,
  visual,
  products: [
    {
      subject: `AeroQbit-D`,
      category: `축사용 제습기 · 냉각·습도 조절`,
      subjectDesc: `축사용 제습/냉각 시스템`,
      aeroQbitImg: productD,
      aeroQbitAlt: `축사용 제습기 AeroQbit-D - 액상 냉매 기반 축사용 제습/냉각 시스템`,
      productList: [
        {
          title: `제품 설명`,
          desc: `· 액상 냉매를 이용한 제습/냉각\n· 축사 구조별 최적 설계 및 적용\n· 중앙복도·편복도·중천장·창문 입기 등\n  다양한 밀폐형 축사 형태에 적용\n· 축사 도면 기반 설계\n· 축사 환기 연계로 효율적 제습/냉각`,
        },
        {
          title: `제품 스펙`,
          content: [
            { label: `냉각기 용량`, value: `축사별 2HP, 5HP 적용` },
            { label: `열교환 모듈`, value: `축사 크기·구조에 따라 적용` },
            { label: `모듈 규격`, value: `400 × 330 × 250 (mm)` },
            { label: `모듈 송풍량`, value: `1,000 CMH (m³/h)` },
            { label: `모듈 적용 개수`, value: `축사별·구조별 상이` },
            { label: `전체 소모전력`, value: `2HP 3.5kW / 5HP 7.5kW 내외 (축사별 상이)` },
            { label: `원격 제어`, value: `LTE 기반 원격 제어 가능` },
            { label: `예측 제어`, value: `축사 온도 추이 예측 기반 제어 (축사별 옵션)` },
          ],
        },
        {
          title: `제품 추가 정보`,
          desc: `· 스마트팜 ICT 융복합 확산사업 등록 기기\n· 조달청 등록에 따른 보조사업 신청 가능`,
        },
      ],
      subject1: `AeroQbit-D 제품설치`,
      subject1Desc: `축사 형태별 설치 형태`,
      installProduct: [
        { label: `중앙복도`, img: centralCorridor, alt: `중앙복도형 돈사 축사용 제습기 AeroQbit-D 설치 형태` },
        { label: `편복도`, img: sideCorridor, alt: `편복도형 축사 제습기 AeroQbit-D 설치 형태` },
        { label: `중천장`, img: doubleHeightCeiling, alt: `중천장형 축사 축사용 제습/냉각 시스템 AeroQbit-D 설치 형태` },
        { label: `입기창`, img: airInletWindow, alt: `입기창 설치형 돈사 제습기 AeroQbit-D 열교환 모듈` },
      ],
      subject2: `AeroQbit-D Installation Location`,
      subject2Desc: `설치·운용 지역`,
      locationMap: dLocationMap,
    },
    {
      subject: `AeroQbit-A`,
      // 검색 키워드 라벨 (제품명 위 eyebrow) — 서버 SEO(seo-routes.json)와 문구 일치
      category: `축사용 공기청정기 · 악취 저감`,
      subjectDesc: `내부 공기 순환 & 악취 저감 시스템`,
      aeroQbitImg: product,
      aeroQbitAlt: `축사용 공기청정기 AeroQbit-A - DEP 기반 축사 악취 저감 장치`,
      productList: [
        { title: `제품 설명`, desc: `내부 공기 순환\n악취 저감 시스템` },
        {
          title: `제품 스펙`,
          content: [
            { label: `제품 크기(cm)`, value: `W103 × D40 × H65` },
            { label: `입력 전원`, value: `220V (단상)` },
            { label: `소모 전력`, value: `150W` },
            { label: `물 입력 규격`, value: `1/4인치 원터치 방식` },
            { label: `물 사용량`, value: `20L/day (배출시간조절가능)` },
            { label: `악취저감방식`, value: `인라인 송풍` },
            { label: `운용위치`, value: `내부 환경에 따른 설치` },
            { label: `유지/보수`, value: `모듈 교환 방식 (교환주기 : 3개월)` },
          ],
        },
        { title: `제품 정보`, desc: `특별사항` },
      ],
      subject1: `AeroQbit-A 제품설치`,
      installProduct: [
        { img: aeroQbitA1, alt: `축사용 공기청정기 AeroQbit-A 돈사 내부 설치 모습` },
        { img: aeroQbitA2, alt: `축사 공기청정기 AeroQbit-A 설치 및 공기 순환 운용 모습` },
      ],
      subject2: `AeroQbit-A 설치장소`,
      subject2Desc: `설치·운용 지역`,
      locationMap: aLocationMap,
    },
  ],
};
